import React from "react"

import Select from "react-select"
import { gql, useQuery } from "urql"

import { WithLoadingIndicator } from "~tailwindui/Basics"

import ordered from "src/ordered"

export type TutorSubjectsProps = {
  subjectId: string
  onChange: (subject: { id: string }) => void
}

const TutorSubjects: React.FC<TutorSubjectsProps> = ({
  subjectId,
  onChange,
}) => {
  const [result] = useQuery({
    query: subjectsQuery,
  })

  return (
    <WithLoadingIndicator
      result={result}
      error="An error occurred while loading your subjects"
    >
      {({ data }) => (
        <Select
          options={ordered(data.subjects, "name")}
          onChange={onChange}
          defaultValue={
            subjectId ? data.subjects.find(s => s.id === subjectId) : null
          }
          getOptionValue={option => option.id}
          getOptionLabel={option => option.name}
        />
      )}
    </WithLoadingIndicator>
  )
}

const subjectsQuery = gql`
  query Subjects {
    subjects {
      id
      name
    }
  }
`

export default TutorSubjects
